import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {message, Breadcrumb, Form, Row, Col, Input, Switch, DatePicker, Space, Button, Select} from "antd";
import {LeftCircleOutlined, FileDoneOutlined} from "@ant-design/icons";
import moment from "moment";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Detail.module.css";

const SpecialDetail = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [systemVersion, setSystemVersion] = useState(0);
    const [activityList, setActivityList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/special/index"});

            handleLoadActivity();

            switch (props.match.path) {
                case "/special/add":
                    setIsSave(true);

                    break;
                case "/special/edit/:specialId":
                    setIsEdit(true);

                    handleLoadSpecial();

                    break;
                default:
                    break;
            }
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    const handleLoadActivity = () => {
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/activity/business/website/v1/select/list",
            data: {},
            success: (response) => {
                setActivityList(response.data);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {},
        });
    };

    const handleLoadSpecial = () => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/special/business/website/v1/find",
            data: {
                specialId: props.match.params.specialId,
            },
            success: (response) => {
                response.data.specialStartDay = moment(response.data.specialStartDay, "YYYY-MM-DD");
                response.data.specialEndDay = moment(response.data.specialEndDay, "YYYY-MM-DD");

                form.setFieldsValue(response.data);

                setSystemVersion(response.data.systemVersion);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(typeof response.data == "undefined" || typeof response.data.specialId == "undefined" || response.data.specialId == null);
            },
        });
    };

    const handleSubmitSpecial = () => {
        if (request.current) {
            return;
        }

        form.validateFields()
            .then((data) => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                data.specialId = props.match.params.specialId;
                data.specialStartDay = data.specialStartDay.format("YYYY-MM-DD");
                data.specialEndDay = data.specialEndDay.format("YYYY-MM-DD");
                data.systemVersion = systemVersion;

                let url = "";
                if (isSave) {
                    url = "/windeal/special/business/website/v1/save";
                }
                if (isEdit) {
                    url = "/windeal/special/business/website/v1/update";
                }

                ChuangShiOS.Util.request(props, {
                    url: Application.host + url,
                    data: data,
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);

                        ChuangShiOS.Util.navigateBack(props, {});
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            })
            .catch((response) => {
                ChuangShiOS.Util.parseResponseError(response);
            });
    };

    const handleBackSpecial = () => {
        ChuangShiOS.Util.navigateBack(props, {});
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<LeftCircleOutlined />} size="large" onClick={handleBackSpecial}>
                                返回
                            </Button>
                        </Button.Group>
                        <Button
                            loading={isLoad}
                            disabled={isError}
                            icon={<FileDoneOutlined />}
                            type="primary"
                            size="large"
                            onClick={handleSubmitSpecial}
                        >
                            提交
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content
                className={Style.content}
                isLoad={isLoad}
                isEmpty={false}
                isError={isError}
                paddingTop={28}
                isScroll={store.main.isFixedContent}
            >
                <Row>
                    <Col flex="auto">
                        <div className={Style.card_title}>基本信息</div>
                    </Col>
                    <Col></Col>
                </Row>
                <Form form={form}>
                    {isSave ? (
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    {...{
                                        labelCol: {flex: "24%"},
                                        wrapperCol: {flex: "auto"},
                                    }}
                                    label="活动名称"
                                    name="activityId"
                                    initialValue={null}
                                    rules={[
                                        {
                                            required: true,
                                            message: "请选择活动名称",
                                        },
                                    ]}
                                >
                                    <Select className={Style.card_field} placeholder="请选择活动名称" allowClear onChange={() => {}}>
                                        {activityList.map((activity, activityIndex) => {
                                            return (
                                                <Select.Option key={activityIndex} value={activity.activityId}>
                                                    {activity.activityName}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    ) : null}
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="名单电话"
                                name="specialPhone"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入名单电话",
                                    },
                                ]}
                            >
                                <Input
                                    disabled={isEdit}
                                    className={Style.card_field}
                                    placeholder="请输入名单电话"
                                    onPressEnter={handleSubmitSpecial}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="开始日期"
                                name="specialStartDay"
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择开始日期",
                                    },
                                ]}
                            >
                                <DatePicker
                                    disabled={isEdit}
                                    className={Style.card_field}
                                    format="YYYY-MM-DD"
                                    placeholder="请选择开始日期"
                                    onPressEnter={handleSubmitSpecial}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="结束日期"
                                name="specialEndDay"
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择结束日期",
                                    },
                                ]}
                            >
                                <DatePicker
                                    disabled={isEdit}
                                    className={Style.card_field}
                                    format="YYYY-MM-DD"
                                    placeholder="请选择结束日期"
                                    onPressEnter={handleSubmitSpecial}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="名单状态"
                                name="specialStatus"
                                initialValue={true}
                                valuePropName="checked"
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择名单状态",
                                    },
                                ]}
                            >
                                <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

SpecialDetail.propTypes = {};

SpecialDetail.defaultProps = {};

export default SpecialDetail;
